import { render } from "./IRPostView.vue?vue&type=template&id=7c5058c6"
import script from "./IRPostView.vue?vue&type=script&lang=js"
export * from "./IRPostView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__